import { useMutation, useQuery } from '@tanstack/react-query';
import {
  certificateLinks,
  deleteMyCompanyCertificate,
  saveMemberCertificate,
  getCertificateTypes,
  getMemberCertificateLocations
} from 'services/members';

export const useMutationSaveCertificate = () => {
  const mutation = useMutation({ mutationFn: saveMemberCertificate });

  return mutation;
};

export const useMutationCertificateLinks = () => {
  const mutation = useMutation({ mutationFn: certificateLinks });

  return mutation;
};

export const useMutationDeleteCertificate = () => {
  const mutation = useMutation({ mutationFn: deleteMyCompanyCertificate });

  return mutation;
};

export const useGetCertificateTypes = () => {
  return useQuery({
    queryKey: ["certificateTypes"],
    queryFn: getCertificateTypes,
    select: (response) => response?.data?.certificateTypes ?? [],
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetMemberCertificatesLocations = ({ memberId }) => {
  return useQuery({
    queryKey: ["memberCertificatesLocations", memberId],
    queryFn: () => getMemberCertificateLocations({ memberId }),
    select: (response) => response?.data ?? [],
    staleTime: 5 * 60 * 1000,
  });
};
